var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1504 3.20723C3.89005 2.94688 3.46794 2.94688 3.20759 3.20723C2.94724 3.46757 2.94724 3.88968 3.20759 4.15003L7.05741 7.99986L3.20763 11.8496C2.94728 12.11 2.94728 12.5321 3.20763 12.7925C3.46798 13.0528 3.89009 13.0528 4.15044 12.7925L8.00022 8.94267L11.85 12.7925C12.1104 13.0528 12.5325 13.0528 12.7928 12.7925C13.0532 12.5321 13.0532 12.11 12.7928 11.8496L8.94303 7.99986L12.7929 4.15003C13.0532 3.88968 13.0532 3.46757 12.7929 3.20723C12.5325 2.94688 12.1104 2.94688 11.85 3.20723L8.00022 7.05705L4.1504 3.20723Z",
    fill: "#FF3C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.45a4b81ce282a1999225b4fbcc14783b.svg";
export { ForwardRef as ReactComponent };